import { gql } from 'graphql-request';

export default gql`
  query Directories(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    directories(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      directories {
        id
        account_id
        doc
        listing
        createdAt
        updatedAt
      }
    }
  }
`;
